import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'
import { IPoint, PropsPoints } from 'utils/interfaces'

const useChangeStartPoint = () =>
  useMutation<IPoint | undefined, Error, PropsPoints>({
    mutationFn: MainApi.changeMissionStartPoint,
  })

export default useChangeStartPoint
